@let obs =
  {
    isLoading: isLoading$ | async,
    serviceCarousel: serviceCarousel$ | async,
    allServices: allServices$ | async,
    isDesktopLgUp: isDesktopLgUp$ | async,
    isTabletMdUp: isTabletMdUp$ | async,
  };

@if (obs.serviceCarousel) {
  @if (obs.serviceCarousel.label && obs.serviceCarousel.items.length) {
    <h2 class="text-b2-s text-md-b2-m text-lg-h4-s service-carousel-title container-v2">
      {{ obs.serviceCarousel.label }}
    </h2>

    <div class="container-v2 service-carousel-content">
      @if (obs.isDesktopLgUp) {
        <sd-swiper [items]="obs.allServices" [config]="config">
          <ng-template let-item="item">
            @if (item === 'allServices') {
              <ng-container *ngTemplateOutlet="allServices"></ng-container>
            } @else {
              <sd-service-carousel-item [serviceCarouselItem]="item"></sd-service-carousel-item>
            }
          </ng-template>
        </sd-swiper>
      } @else {
        <ng-container *ngTemplateOutlet="allServices"></ng-container>

        @for (serviceCarouselItem of obs.serviceCarousel.items; track serviceCarouselItem.url) {
          <sd-service-carousel-item [serviceCarouselItem]="serviceCarouselItem"></sd-service-carousel-item>
        }
      }
    </div>
  }
} @else if (obs.isLoading) {
  <div class="container-v2 service-carousel-skeleton sd-group-skeleton-gradient-wave">
    <div class="service-carousel-skeleton-top">
      <div class="service-carousel-title sd-skeleton"></div>
      <div class="service-carousel-skeleton-paging sd-skeleton"></div>
    </div>
    <div class="service-carousel-content">
      @let numberOfSkeletons = 6;
      @for (i of [].constructor(numberOfSkeletons); track $index) {
        <div class="service-carousel-skeleton-item sd-skeleton"></div>
      }
    </div>
  </div>
}

<ng-template #allServices>
  @if (obs.serviceCarousel) {
    <div class="service-carousel-all">
      <a [routerLink]="obs.serviceCarousel.link">
        <ng-container *ngTemplateOutlet="allServicesContent"></ng-container>
      </a>
    </div>
  }
</ng-template>

<ng-template #allServicesContent>
  @if (obs.serviceCarousel) {
    <h4 class="text-b4-l-700 text-xl-b1-l-700">{{ obs.serviceCarousel.buttonText }}</h4>
    <button
      sdNavButton
      class="button-nav-link"
      [routerLink]="obs.serviceCarousel.link"
      [icon]="iconTypes.ARROW_NEXT"
      size="{{ obs.isDesktopLgUp ? 'l' : obs.isTabletMdUp ? 'm' : 's' }}"
    ></button>
  }
</ng-template>
